import React from "react";
import { Typography } from "antd";
import { getAvatarColor, getInitials } from "@/utils/avatarUtils";
import PersonIcon from "@/assets/icons/person.svg?react";

const { Text } = Typography;

interface AvatarWithInitialsProps {
  name: string | null;
  avatarSize?: number;
  avatarFontSize?: number;
  labelFontSize?: number;
  showLabel?: boolean;
}

const AvatarWithInitials = ({
  name,
  avatarSize = 32,
  avatarFontSize = 14,
  labelFontSize = 14,
  showLabel = true,
}: AvatarWithInitialsProps) => {
  if (!name) {
    return <Text>-</Text>;
  }

  if (name === "Unassigned")
    return (
      <div className="flex items-center gap-2">
        <div className="flex items-center justify-center rounded-full p-1 bg-[#D9D9D9] text-[#556C75] font-bold overflow-hidden">
          <PersonIcon style={{ width: "16px", height: "16px" }} />
        </div>
        {showLabel ? (
          <Text style={{ fontSize: `${labelFontSize}px` }}>Unassigned</Text>
        ) : null}
      </div>
    );

  return (
    <div className="flex items-center gap-2">
      <div
        className="flex items-center justify-center rounded-full text-white font-bold"
        style={{
          width: `${avatarSize}px`,
          height: `${avatarSize}px`,
          backgroundColor: getAvatarColor(name),
          fontSize: `${avatarFontSize}px`,
          lineHeight: `${avatarSize}px`,
        }}
      >
        {getInitials(name)}
      </div>
      {showLabel ? (
        <Text ellipsis style={{ fontSize: `${labelFontSize}px` }}>
          {name}
        </Text>
      ) : null}
    </div>
  );
};

export default AvatarWithInitials;
